document.addEventListener("DOMContentLoaded", () => {
	const sliders = Array.from(document.querySelectorAll(".wp-block-wpb-slider"));

	if (!sliders.length) {
		return;
	}

	sliders.forEach((swiper, index) => {
		const speedModifier = index * 300;
		const itemsMobile = +swiper.dataset.itemsRowMobile || 1;
		const itemsTablet = +swiper.dataset.itemsRowTablet || 2;
		const itemsDesktop = +swiper.dataset.itemsRowDesktop || 3;
		const speed = +swiper.dataset.speed || 300;
		const delay = +swiper.dataset.delay;
		const enableAnimationLoop = swiper.dataset.enableAnimationLoop === "true";
		const spaceBetween = +swiper.dataset.spaceBetween;
		const enableNavigation = swiper.dataset.enableNavigation === "true";
		const enablePagination = swiper.dataset.enablePagination === "true";
		const sliderMode = swiper.dataset.sliderMode || "default";

		const wrapper = swiper.closest(".wp-block-wpb-slider-wrapper") ?? swiper;

		let swiperConfig;

		if (sliderMode === "carousel") {
			swiperConfig = {
				modules: [window.EffectCarousel],
				effect: "carousel",
				slidesPerView: "auto",
				speed: speed,
				spaceBetween: spaceBetween,
				slideClass: "wp-block-wpb-slide",
				grabCursor: true,
				loop: enableAnimationLoop,
				loopAdditionalSlides: 1,
				autoplay: {
					delay: delay + speedModifier,
					pauseOnMouseEnter: true,
				},
				carouselEffect: {
					opacityStep: 0.33,
					scaleStep: 0.2,
					sideSlides: 1,
				},
				on: {
					progress() {
						this.slides.forEach((slideEl) => {
							const absProgress = Math.abs(slideEl.progress);
							slideEl.style.opacity = Math.max(0, 1 - absProgress * 0.4);
						});
					},
					setTransition(duration) {
						this.slides.forEach((slideEl) => {
							slideEl.style.transitionDuration = `${duration}ms`;
						});
					},
				},
			};
		} else {
			swiperConfig = {
				slidesPerView: itemsMobile,
				speed: speed,
				spaceBetween: spaceBetween,
				slideClass: "wp-block-wpb-slide",
				loop: enableAnimationLoop,
				autoplay: {
					delay: delay + speedModifier,
					pauseOnMouseEnter: true,
				},
				breakpoints: {
					840: {
						slidesPerView: itemsTablet,
					},
					1200: {
						slidesPerView: itemsDesktop,
					},
				},
			};
		}

		if (enablePagination) {
			swiperConfig.pagination = {
				el: wrapper.querySelector(".wp-block-wpb-slider-swiper-pagination"),
				clickable: true,
			};
		}

		if (enableNavigation) {
			swiperConfig.navigation = {
				nextEl: wrapper.querySelector(".wp-block-wpb-slider-button-next"),
				prevEl: wrapper.querySelector(".wp-block-wpb-slider-button-prev"),
			};
		}

		new Swiper(swiper, swiperConfig);
	});
});
